import { checkParams, zeroUnit, soFarDate, timePeriod } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	if (this.isResurveyNotInHospital) {
		return false
	}
	if (this.isPAIC && this.isFirstVisit) {
		return false
	}

	const agent = injured.agent || ''

	let arr = []

	const hasAgent = !['0', ''].includes(agent.hasAgent)

	if (hasAgent) {
		arr = arr.concat([
			{
				label: '代理人姓名',
				value: agent.agentor,
			},
			{
				label: '代理人电话',
				value: agent.agentPhone,
			},
		])
		if (this.isHomeInvestigate) {
			arr.push({
				label: '与伤者关系',
				value: setting.agentRelationMap[agent.relation],
				key: 'relation',
			})
			if (agent.relation === '04') {
				arr.push({
					label: '其他',
					value: agent.relationDesc,
					key: 'relationDesc',
				})
			}
		}
		arr.push({
			label: '备注（非必填）',
			value: agent.remark,
		})
	}

	const obj = {
		title: '代理人信息',
		children: arr,
		show: {
			hasAgent,
		},
	}

	return obj
}
